import clsx from "clsx";

import { ReactComponent as MarkIcon } from "../../../assets/icons/mark.svg";
import { ReactComponent as DayIcon } from "../../../assets/icons/daysOpt.svg";
import { ReactComponent as Star } from "../../../assets/icons/star-filled.svg";

import styles from '../headerBtn.module.scss';
import { useSelector } from 'react-redux';

const days = ['понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу', 'воскресенье'];

const colorMarcer = {
  Active: 'rgb(160, 212, 203)',
  Paused: 'rgb(160, 212, 203)',
  Vacancy: 'rgb(255, 249, 155)',
  Available: 'rgb(237, 156, 166)',
  AvailableNewChains: 'rgb(201, 185, 247)',
};

const LegendMapSection = () => {
  const {darkTheme: {isDarkTheme}} = useSelector((state: any) => state.theme.theme);
  return (
    <div className={styles.legend}>
      <div className={styles.legend__block}>
        <div className={styles.legend__item}>
          <div className={styles.legend__elem}>
            <div className={styles.rating}>
              {Array.from({ length: 5 }, (_, index) => (
                <Star color={isDarkTheme ? 'white' : 'black'} key={index} />
              ))}
            </div>
          </div>
          <p>Степень востребованности ТТ</p>
        </div>
        <div className={styles.legend__item}>
          <div className={styles.legend__elem}>87%</div>
          <p>% качественных отчётов</p>
        </div>
      </div>
      <div className={styles.legend__block}>
        {days.map((day: string, index: number) => (
          <div className={styles.legend__item} key={index}>
            <div className={styles.legend__icon}>
              <MarkIcon style={{ fill: index === 2 || index === 4 ? colorMarcer.Vacancy : colorMarcer.Active }} />
              <DayIcon
                className={clsx(styles.legend__iconDay, styles[`legend__iconDay_${index}`])}
                style={{
                  fill: index === 2 || index === 4
                    ? colorMarcer.Vacancy : colorMarcer.Active, stroke: index === 2 || index === 4 ? colorMarcer.Vacancy
                      : colorMarcer.Active
                }} />
            </div>
            <p>{`Визит в ТТ в ${day}`}</p>
          </div>
        ))}
      </div>
      <div className={styles.legend__block} style={{ flexWrap: 'nowrap' }} >
        <div className={styles.legend__item} >
          <div className={styles.legend__icon}><MarkIcon style={{ fill: colorMarcer.Active }} /></div>
          <p>Обслуживаются или Временно не активна - ТТ со статусом мерчендайзера "Активный", "Замена",
            "Отгул" или "Больничный", "Отпуск" (отображается с разбивкой по дням недели)</p>
        </div>
        <div className={styles.legend__item}>
          <div className={styles.legend__icon}><MarkIcon style={{ fill: colorMarcer.Vacancy }} /></div>
          <p>Обслуживаются (вакансия) - ТТ со статусом мерчендайзера "Вакант", "Долгий вакант",
            или "Нерентабельный" (отображается с разбивкой по дням недели)</p>
        </div>
        <div className={styles.legend__item}>
          <div className={styles.legend__icon}><MarkIcon style={{ fill: colorMarcer.Available }} /></div>
          <p>Доступны (действующие сети) - ТТ тех же сетей, по которым уже проводится мерчендайзинг, но не обслуживаются в согласованной АП контракта</p>
        </div>
        <div className={styles.legend__item}>
          <div className={styles.legend__icon}><MarkIcon style={{ fill: colorMarcer.AvailableNewChains }} /></div>
          <p>Доступны (новые сети) - рейтинговые ТТ других сетей, по которым уже проводится мерчендайзинг, но не обслуживаются в согласованной АП контракта</p>
        </div>
      </div>
    </div>
  );
};

export default LegendMapSection;